import localStorage from "@/libs/localStorage";
import defaultAvatar from "@/assets/img/user/avatar1.png";

const state = {
  token: localStorage.get("token"),
  username:
    localStorage.get("userinfo") && localStorage.get("userinfo")["userName"],
  nickName:
    localStorage.get("userinfo") && localStorage.get("userinfo")["TrueName"],
  userId: "",
  avatar:
    (localStorage.get("userinfo") && localStorage.get("userinfo")["avatar"]) ||
    defaultAvatar,
  registerMode:
    localStorage.get("userinfo") && localStorage.get("userinfo")["registerMode"]
};

const getters = {
  getToken: state => state.token,
  getUsername: state => state.username,
  getNickName: state => state.nickName,
  getAvatar: state => state.avatar,
  getRegisterMode: state => state.registerMode
};

const action = {};

const mutations = {
  setToken(state, token) {
    state.token = token;
  },
  setUsername(state, username) {
    state.username = username;
  },
  setNickName(state, trueName) {
    state.nickName = trueName;
  },
  setRegisterMode(state, registerMode) {
    state.registerMode = registerMode;
  },
  clearLocalStorage(state) {
    state.token = "";
    state.username = "";
    state.nickName = "";
    state.getRegisterMode = "";
  }
};

export default {
  state,
  getters,
  action,
  mutations
};
